import { api } from "~/api";
import type {
  GlobalScheduleRule,
  GlobalScheduleRulesSummary,
  ImportGlobalScheduleRulesResponse,
} from "./global-schedule-rules.types";

export const importGlobalScheduleRules = async (
  file: File,
): Promise<ImportGlobalScheduleRulesResponse> => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await api.post<{ data: ImportGlobalScheduleRulesResponse }>(
    "/admin/global-schedule-rules/import",
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );

  return response.data.data;
};

export const getGlobalScheduleRulesSummary =
  async (): Promise<GlobalScheduleRulesSummary> => {
    const response = await api.get<{ data: GlobalScheduleRulesSummary }>(
      "/admin/global-schedule-rules/summary",
    );

    return response.data.data;
  };

export const getGlobalScheduleRules = async (): Promise<
  GlobalScheduleRule[]
> => {
  const response = await api.get<{ data: GlobalScheduleRule[] }>(
    "/admin/global-schedule-rules",
  );

  return response.data.data;
};

export const deleteAllGlobalScheduleRules = async (): Promise<void> => {
  await api.delete("/admin/global-schedule-rules");
};
